const model = {
  message: '',
  status: '',
  statusText: ''
}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/error.js